// Thèmes
export var OFFICIALS_EDITOR_THEMES = ["coy", "dark", "funky", "okaidia", "solarizedlight", "tomorrow", "twilight"];

export var ADDITIONALS_EDITOR_THEMES = ["atom-dark", "base16-ateliersulphurpool.light", "cb", "darcula", "duotone-dark", "duotone-earth", "duotone-forest", "duotone-light", "duotone-sea", "duotone-space", "ghcolors", "hopscotch", "pojoaque", "vs", "xonokai"];

// Tabs
export var DEFAULT_PREVIEW_TAB_TEXT = "Preview";
export var DEFAULT_EDIT_TAB_TEXT = "Edit";
export var DEFAULT_TAB_COLOR = "#905";

export var DEFAULT_TABS_WRAPPER_STYLES = {
  marginBottom: "20px"
};

export var DEFAULT_TABS_STYLES = {
  borderBottom: "5px solid " + DEFAULT_TAB_COLOR,
  paddingLeft: "20px",
  marginBottom: "-.5em"
};

export var DEFAULT_TAB_STYLES = {
  display: "inline-block",
  padding: "10px 20px",
  cursor: "pointer",
  background: "none",
  fontFamily: "Consolas, Menlo, Monaco",
  color: DEFAULT_TAB_COLOR
};

export var DEFAULT_TAB_ACTIVE_STYLES = {
  background: DEFAULT_TAB_COLOR,
  color: "#fff"
};